module.exports = __webpack_public_path__ + "static/media/visa-master.1d10a8cf.png";